<template>
  <div class="container mt-4">
    <div class="card p-4 shadow-sm">
      <div class="d-flex align-items-center mb-4">
        <button class="btn btn-outline-secondary me-3" @click="volver">
          ← Regresar
        </button>
        <h3 class="m-0 flex-grow-1 text-center">Cierre de Caja</h3>
        <button class="btn btn-outline-primary ms-auto me-2" @click="imprimirCierre">
          🖨 Imprimir Cierre
        </button>
        <button class="btn btn-outline-secondary" @click="descargarFormatoCorte">
          📄 PDF Formato Corte
        </button>
      </div>
      <div class="mb-3 d-flex align-items-center gap-2 flex-wrap">
        <label class="form-label m-0"><strong>Desde:</strong></label>
        <input
          type="date"
          v-model="filtro.fechaInicio"
          class="form-control"
          style="max-width: 170px"
          @change="cargarCierre"
        />
        <input
          type="time"
          v-model="filtro.horaInicio"
          class="form-control"
          style="max-width: 125px"
          @change="cargarCierre"
        />
        <label class="form-label m-0 ms-2"><strong>Hasta:</strong></label>
        <input
          type="date"
          v-model="filtro.fechaFin"
          class="form-control"
          style="max-width: 170px"
          @change="cargarCierre"
        />
        <input
          type="time"
          v-model="filtro.horaFin"
          class="form-control"
          style="max-width: 125px"
          @change="cargarCierre"
        />
      </div>

      <div v-if="cierre">
        <ul class="list-group mb-3">
          <li class="list-group-item">
            <strong>Período:</strong>
            {{
              cierre.periodo
                ? cierre.periodo.inicio.slice(0, 16) +
                  " → " +
                  cierre.periodo.fin.slice(0, 16)
                : cierre.fecha
            }}
          </li>
          <li class="list-group-item">
            <strong>Huespedes Ingresados:</strong>
            {{ cierre.huespedes_ingresados }}
          </li>
        </ul>

        <h5 class="mb-2">Ingresos</h5>
        <ul class="list-group mb-4">
          <li class="list-group-item d-flex justify-content-between">
            <span>Hospedaje</span>
            <strong>Q{{ Number(cierre.ingresos.hospedaje).toFixed(2) }}</strong>
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <span>Servicios Extra</span>
            <strong
              >Q{{ Number(cierre.ingresos.servicios_extra).toFixed(2) }}</strong
            >
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <span>Restaurante</span>
            <strong
              >Q{{ Number(cierre.ingresos.restaurante).toFixed(2) }}</strong
            >
          </li>
          <li class="list-group-item d-flex justify-content-between bg-light">
            <span><strong>Total Ingresos</strong></span>
            <strong class="text-primary"
              >Q{{ Number(cierre.ingresos.total_general).toFixed(2) }}</strong
            >
          </li>
        </ul>

        <h5 class="mb-2">Detalle de Pagos por Sección</h5>
        <div v-if="Object.keys(cierre.pagos).length > 0">
          <div v-for="(grupo, uso) in cierre.pagos" :key="uso" class="mb-3">
            <div class="d-flex align-items-center gap-2 mb-1">
              <h6
                class="m-0"
                :class="uso === 'Facturado' ? 'text-primary' : 'text-secondary'"
              >
                {{ uso }}
              </h6>
              <small v-if="uso === 'No Facturado'" class="text-muted"
                >(solo efectivo)</small
              >
            </div>
            <ul class="list-group">
              <li
                v-for="(cantidad, metodo) in grupo"
                :key="metodo"
                class="list-group-item d-flex justify-content-between"
              >
                <span>{{ metodo }}</span>
                <strong>Q{{ Number(cantidad).toFixed(2) }}</strong>
              </li>
              <li
                class="list-group-item d-flex justify-content-between bg-light"
              >
                <span
                  ><strong>Subtotal {{ uso }}</strong></span
                >
                <strong
                  >Q{{
                    Object.values(grupo)
                      .reduce((s, v) => s + Number(v), 0)
                      .toFixed(2)
                  }}</strong
                >
              </li>
            </ul>
          </div>
        </div>
        <div v-else class="alert alert-secondary">
          No hay pagos registrados para este período.
        </div>

        <h5 class="mb-2">Resumen Pagos</h5>
        <ul class="list-group mb-4">
          <li class="list-group-item d-flex justify-content-between">
            <span>Total Facturado</span>
            <strong
              >Q{{
                Number(cierre.resumen_pagos.total_facturado).toFixed(2)
              }}</strong
            >
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <span>Efectivo No Facturado</span>
            <strong
              >Q{{
                Number(cierre.resumen_pagos.total_no_facturado).toFixed(2)
              }}</strong
            >
          </li>
          <li
            v-if="Number(cierre.credito_habitacion) > 0"
            class="list-group-item d-flex justify-content-between"
          >
            <span>Crédito a Habitación</span>
            <strong class="text-warning"
              >Q{{ Number(cierre.credito_habitacion).toFixed(2) }}</strong
            >
          </li>
          <li class="list-group-item d-flex justify-content-between bg-light">
            <span><strong>Total Pagos</strong></span>
            <strong class="text-success"
              >Q{{
                Number(cierre.resumen_pagos.total_pagos).toFixed(2)
              }}</strong
            >
          </li>
        </ul>

        <!-- Créditos de Habitación: sección de alerta si hay montos -->
        <div
          v-if="Number(cierre.credito_habitacion) > 0"
          class="alert alert-warning d-flex align-items-start gap-2 mb-4"
        >
          <i class="bx bx-info-circle fs-5 mt-1"></i>
          <div>
            <strong>Créditos de Habitación Pendientes:</strong>
            Q{{ Number(cierre.credito_habitacion).toFixed(2) }}<br />
            <small>
              Pagos de restaurante cargados a habitación — se cobrarán al
              momento del checkout del huésped.
            </small>
          </div>
        </div>

        <h5 class="mb-2">Estado del Cuadre</h5>
        <ul class="list-group">
          <li class="list-group-item d-flex justify-content-between">
            <span>Diferencia</span>
            <strong
              :class="{
                'text-success': cierre.estado_cuadre === 'Cuadre exacto',
                'text-danger': cierre.estado_cuadre === 'Saldo pendiente',
                'text-info': cierre.estado_cuadre === 'Saldo a favor',
              }"
              >Q{{ Number(cierre.diferencia).toFixed(2) }}</strong
            >
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <span>Estado</span>
            <span
              :class="{
                'badge bg-success': cierre.estado_cuadre === 'Cuadre exacto',
                'badge bg-danger': cierre.estado_cuadre === 'Saldo pendiente',
                'badge bg-info': cierre.estado_cuadre === 'Saldo a favor',
              }"
              >{{ cierre.estado_cuadre }}</span
            >
          </li>
        </ul>
      </div>

      <div v-else class="text-center text-muted my-5">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-3">Cargando cierre de caja...</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/config/axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "CierreCajaDetalle",
  data() {
    const hoy = new Date();
    const manana = new Date(hoy);
    manana.setDate(manana.getDate() + 1);
    return {
      cierre: null,
      filtro: {
        fechaInicio: hoy.toLocaleDateString("fr-CA"),
        horaInicio: "08:00",
        fechaFin: manana.toLocaleDateString("fr-CA"),
        horaFin: "08:00",
      },
    };
  },
  computed: {
    datetimeInicio() {
      return `${this.filtro.fechaInicio} ${this.filtro.horaInicio}:00`;
    },
    datetimeFin() {
      return `${this.filtro.fechaFin} ${this.filtro.horaFin}:00`;
    },
  },
  async mounted() {
    await this.cargarCierre();
  },
  methods: {
    volver() {
      this.$router.push("/inicio");
    },
    imprimirCierre() {
      const params = new URLSearchParams({
        fecha_inicio: this.datetimeInicio,
        fecha_fin: this.datetimeFin,
      });
      this.$router.push(`/imprimir-cierre-caja?${params.toString()}`);
    },
    async descargarFormatoCorte() {
      try {
        const response = await axios.get(
          `${API_URL}/cierre-caja-formato-corte-pdf`,
          {
            params: {
              fecha_inicio: this.filtro.fechaInicio,
              hora_inicio: this.filtro.horaInicio,
              fecha_fin: this.filtro.fechaFin,
              hora_fin: this.filtro.horaFin,
            },
            responseType: "blob",
          }
        );
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Corte_Caja_${this.filtro.fechaInicio}_${this.filtro.fechaFin}.pdf`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Error descargando PDF de formato corte:", error);
      }
    },
    async cargarCierre() {
      try {
        this.cierre = null;
        const params = {
          fecha_inicio: this.datetimeInicio,
          fecha_fin: this.datetimeFin,
        };
        const res = await axios.get(`${API_URL}/cierre-caja`, { params });
        this.cierre = res.data;
      } catch (error) {
        console.error("Error al cargar cierre de caja:", error);
      }
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
  text-align: center;
}
</style>
